import { gql, useApolloClient } from "@apollo/client";
import { useAsyncExecutor } from "async-executor-hook";

import { ProcessingModal } from "../../common/components/ProcessingModal";
import FilterIcon from "../../images/icon_arrow_down.svg"; // TODO: Change to filter icon
import PDFIcon from "../../images/icon_pdf.svg";
import { GRAPHQL_METHODS } from "../../utils/constants";
import { dateToRegularFormat } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";
import Pagination from "../Pagination/Pagination";
import StatusTag from "../StatusTag/StatusTag";
import {
  AuxiliarContainer,
  ClearButton,
  ComplaintContainer,
  DataContainer,
  EmptyResult,
  Footer,
  GridContainer,
  SubTitle,
} from "./ComplaintsStatusTableStyles";

const populateComplaint = (complaints, downloadFile) => {
  // TODO: update StatusTag
  return complaints.map((complaint, index) => {
    return (
      <ComplaintContainer key={index}>
        <GridContainer>
          <h3 className="center-position">{complaint.caseNumber}</h3>
          <h3 className="center-position">{complaint.business}</h3>
          <div className="complaint-status">
            <StatusTag status={complaint.status} />
          </div>
          <h3 className="center-position">{complaint.area}</h3>
          <h3 className="left-position">{complaint.reason}</h3>
          <h3 className="center-position">
            {dateToRegularFormat(complaint.registerDate.split("T")[0])}
          </h3>
          <h3 className="center-position">
            <img
              style={{ cursor: "pointer" }}
              src={PDFIcon}
              alt={"Exportar a PDF"}
              onClick={() => {
                downloadFile.execute({ complaintId: complaint.caseNumber });
              }}
            />
          </h3>
        </GridContainer>
      </ComplaintContainer>
    );
  });
};
export default function ComplaintsStatusTable(props) {
  const { complaints, onPageClick, pageHook, numPages, clearSearchParams } =
    props;

  const client = useApolloClient();

  const GET_PDF = gql`
    query ($caseNumber: String!) {
      getReportToPDF(caseNumber: $caseNumber)
    }
  `;

  const downloadFile = useAsyncExecutor(
    async (params: any) => {
      const resp = await networkGraphqlRequest(
        GRAPHQL_METHODS.QUERY,
        client,
        GET_PDF,
        {
          caseNumber: params.complaintId,
        }
      );
      return resp.getReportToPDF;
    },
    {
      onSuccess: (urlPdf) => {
        window.open(urlPdf);
      },
    }
  );

  return (
    <div>
      {numPages !== 0 ? (
        <div>
          <ProcessingModal status={downloadFile.status}></ProcessingModal>

          <GridContainer>
            <SubTitle className="center-position">NÚMERO</SubTitle>
            <SubTitle className="center-position">UN</SubTitle>
            <SubTitle className="center-position">ESTADO</SubTitle>
            <SubTitle className="center-position">ÁREA</SubTitle>
            <SubTitle className="left-position">MOTIVO</SubTitle>
            <SubTitle className="center-position">FECHA DE INGRESO</SubTitle>
            <SubTitle className="center-position">PDF</SubTitle>
          </GridContainer>
          <DataContainer>
            {populateComplaint(complaints, downloadFile)}
          </DataContainer>
          <Footer>
            <Pagination
              numPages={numPages}
              pageHook={pageHook}
              onPageClick={onPageClick}
            />
            <ClearButton onClick={clearSearchParams}>
              <img src={FilterIcon} alt="Limpiar filtros" />
              <h2>Limpiar filtros</h2>
            </ClearButton>
          </Footer>
        </div>
      ) : (
        <AuxiliarContainer>
          <EmptyResult>No hay resultados que mostrar</EmptyResult>
        </AuxiliarContainer>
      )}
    </div>
  );
}
